module.exports = __webpack_public_path__ + "static/media/cifarLogo.d3fa3437.jpg";